import * as XLSX from "xlsx";
import {useEffect, useState} from "react";
import {getBsrsSurveys} from "../api/getBsrsSurveys";
import {getBsrsFollowUps} from "../api/getBsrsFollowUps";
import {saveWorkbook} from "../../../utils/excel";

export const useBsrsManagement = ({ userToken }) => {
  const [bsrsSurveys, setBsrsSurveys] = useState([]);
  const [bsrsFollowUps, setBsrsFollowUps] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetch = async () => {
    setIsLoading(true);
    try {
      const tempBsrsSurveys = await getBsrsSurveys(userToken);
      const tempBsrsFollowUps = await getBsrsFollowUps(userToken);
      setBsrsSurveys(tempBsrsSurveys)
      setBsrsFollowUps(tempBsrsFollowUps)
    } catch(e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }

  const exportData = () => {
    const workbook = XLSX.utils.book_new();
    const values = [['年齡', '性別', '睡眠困難，譬如難以入睡、易醒或早醒', '感覺緊張或不安', '覺得容易苦惱或動怒', '感覺憂鬱、心情低落', '覺得比不上別人', '總分', '有自殺的想法']]
    for (const row of bsrsSurveys) {
      values.push([
        row.age,
        row.gender,
        row.answers[0],
        row.answers[1],
        row.answers[2],
        row.answers[3],
        row.answers[4],
        row.score,
        row.answers[5],
      ])
    }
    values.push([])
    values.push([])
    values.push(['若您有心理相關困擾，且願意留下您的姓名及聯繫電話，將有專人回電給您。'])
    values.push(['姓名', '電話', '請描述近期的壓力事件'])
    for (const row of bsrsFollowUps) {
      values.push([
        row.name,
        row.telephone,
        row.pressureEvent
      ])
    }
    const worksheet = XLSX.utils.aoa_to_sheet(values);
    XLSX.utils.book_append_sheet(workbook, worksheet, '總表');
    saveWorkbook({ workbook, fileName: 'BSRS系統數據'})
  }

  useEffect(() => {
    if (userToken) {
      fetch()
    }
  }, [userToken]);

  return { isLoading, exportData }
}